import React from "react";
import { useEffect, useState } from "react";
import { useAuth } from "../../Context/AuthProvider";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { url } from "../../Constant";

const CampaignNumberEdit = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [errorEnable, setErrorEnable] = useState(false);
  const params = useParams();
  const { auth } = useAuth();
  const [number, setNumber] = useState(params?.number);

  const EditCallInitiate = (e) => {
    e.preventDefault();

    setErrorEnable(true);
    setLoader(true);

    var formData = new FormData();
    formData.append("s_no", params.sno);
    formData.append("caller_id", number);

    if (number !== "") {
      axios
        .post(url + "tcs-update-campaign-numbers", formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.message === "Number update successfully") {
              setLoader(false);
              toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
              });
              setTimeout(() => {
                navigate(-1);
              }, 1500);
            }
          } else {
            toast.error("An error occurred", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1500,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          // Handle other errors (e.g., network errors)
          toast.error("An error occurred", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
        })
        .finally(() => {
          setLoader(false);
        });
    } else {
      // Handle password fields being empty
      setLoader(false);
    }
  };

  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>Campaign Update</h3>
              </div>
            </div>
            {/* <div className="uk-width-1-3">
            <div className="dashboardIntro uk-text-right">
              <button>EXPORT DATA</button>
            </div>
          </div> */}

            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                // className="uk-subnav uk-subnav-pill"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                <li onClick={() => sessionStorage.setItem("ct_licked", 0)}>
                  <a href="#">Number</a>
                </li>
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            {auth.role === "2" && (
              <>
                <li>
                  <div className="dashboardWrp">
                    <div className="uk-container uk-container-small">
                      <div className="dashboardTop">
                        <div uk-grid="" className="uk-grid">
                          <div className="uk-width-2-3">
                            <div className="dashboardIntro">
                              {/* <h3>Campaign Number Edit</h3> */}
                            </div>
                          </div>
                        </div>

                        <form action="javascript:void(0);">
                          <div className="formCreateMain">
                            <div className="uk-grid uk-grid-small">
                              {/* <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Add details</legend>
                </div> */}
                              <div className="uk-width-1-2@m uk-margin-top">
                                <label>Number</label>
                                <input
                                  className="uk-input"
                                  type="number"
                                  aria-label="Input"
                                  placeholder="Edit Number"
                                  value={number}
                                  onChange={(e) => {
                                    setNumber(e.target.value);
                                  }}
                                />
                                {errorEnable && number === "" && (
                                  <div className="formErrors">
                                    Field is required
                                  </div>
                                )}
                              </div>

                              <div className="uk-width-1-1@m uk-float-right uk-margin-top">
                                <div className="formActionBtn uk-text-right">
                                  <button
                                    className="pinkBtn"
                                    onClick={EditCallInitiate}
                                  >
                                    {loader ? (
                                      <div uk-spinner="" className="loader">
                                        Adding
                                      </div>
                                    ) : (
                                      "Update"
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  {/* <CreateIVR /> */}
                </li>
              </>
            )}
            {auth.role === "1" && (
              <>
                <li>{/* <Companies /> */}</li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CampaignNumberEdit;
